import { withAPIAccount } from '../../lib/http/api';
import { parsedResponse } from '../../lib/http/http';
import { AccountType, IAPIresponse } from '../../model';
import { ICreateAccount } from '../../model/api-modules';
import { ADMIN_PREFIX } from '../config';

// 创建用户
export const createAccount = (body: ICreateAccount) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/user`;
      const response = await api.commonRequest('POST', url, body);
      const res = await parsedResponse<IAPIresponse>(response, 'data');
      return res;
    } catch (error: any) {
      return error?.apiError;
    }
  });

interface IStaff {
  staffAccountName: string;
  staffCombinedName: string;
  staffDisplayName: string;
}

export const getStaffList = (searchText: string) =>
  withAPIAccount(AccountType.Cross, async (api) => {
    try {
      const response = await api.commonRequest(
        'POST',
        'https://ntsgw.woa.com/api/sso/dos-interface-server/open-api/config/hrmd/md-api-public-core-selector-staff/HR-OPEN-DATA/data',
        {
          queryCondition: {
            argMap: {
              likeMode: 'full',
              staffCombinedNameLike: searchText,
            },
            limit: 20,
          },
        },
        {
          'hrgw-appname': 'HR-OPEN-DATA',
        }
      );
      const res = await parsedResponse<{ content: IStaff[] }>(response, 'data');
      return res.content;
    } catch (error: any) {
      return [];
    }
  });
